import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const LoaderBoxStyled = styled(Box)`
  background-color: ${({ theme }) => theme.colors.grey[50]};
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
`;

export const TradeMarkWrapper = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  flexGrow: { sm: 1 },
  p: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
`;
